import { render } from "./RadioLabel.vue?vue&type=template&id=75dd66b0&ts=true"
import script from "./RadioLabel.vue?vue&type=script&lang=ts"
export * from "./RadioLabel.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/wVusKqw4/1/kenniss/platform/educator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__